





































































import Vue from "vue";
import { Task, ApiPostTask, ApiPatchTask, updateTeamTaskAsync, createTeamTaskAsync } from "@/tasks";
import storeHelper from "../../store/store-helper";
import moment from "moment";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "@/components/dialogs/ZenyaDialog.vue";
import Utils from "@/utils";
import { decode } from "html-entities";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "TeamTask",
    props: {
        mode: {
            default: "add",
            type: String as () => "add" | "edit" | "finish"
        },
        taskTitle: {
            default: "",
            type: String
        },
        taskDescription: {
            default: "",
            type: String
        },
        taskDeadline: {
            default: "",
            type: String
        },
        teamID: String,
        taskID: String
    },
    data: function () {
        return {
            validForm: true,
            deadlineMenu: false,
            localTaskTitle: "" as string,
            localTaskDescription: "" as string,
            localTaskDeadline: "" as string
        };
    },
    components: {},
    computed: {
        requiredRules() {
            return v => !!v || `${this.$t("general.validation.isRequired")}`;
        },
        formattedTaskDeadline(): string {
            return this.localTaskDeadline ? Utils.formatDate(new Date(this.localTaskDeadline), this.$user?.date_format) : null;
        }
    },
    async created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.okClickedAsync });
        this.localTaskTitle = decode(this.taskTitle);
        this.localTaskDescription = decode(this.taskDescription);
        this.localTaskDeadline = this.taskDeadline;
    },
    methods: {
        required() {
            return v => !!v?.trim() || `${this.$t("general.validation.isRequired")}`;
        },
        async okClickedAsync(): Promise<boolean> {
            if (this.mode == "add") return await this.addTeamTaskAsync();
            else if (this.mode == "edit") return await this.editTeamTaskAsync();
            else if (this.mode == "finish") return await this.finishTeamTaskAsync();
            else return true;
        },
        async addTeamTaskAsync(): Promise<boolean> {
            if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) return false;

            let postTask: ApiPostTask = {
                title: this.localTaskTitle,
                description: this.localTaskDescription,
                deadline_date: this.localTaskDeadline ? moment.utc(this.localTaskDeadline).toDate().toAPIDateString() : null,
                is_important: false,
                assigned_to_team_id: this.teamID
            };

            let result = await createTeamTaskAsync(postTask);

            if (result.success) this.$emit("task-added");
            return true;
        },
        async editTeamTaskAsync(): Promise<boolean> {
            if (!(this.$refs.form as Vue & { validate: () => boolean }).validate()) return false;

            //If nothing has changed close dialog
            if (
                this.localTaskTitle == decode(this.taskTitle) &&
                this.localTaskDescription == decode(this.taskDescription) &&
                this.localTaskDeadline == this.taskDeadline
            )
                return true;

            let patchTask: ApiPatchTask = {
                title: this.localTaskTitle,
                description: this.localTaskDescription,
                deadline_date: this.localTaskDeadline ? moment.utc(this.localTaskDeadline).toDate().toAPIDateString() : null
            };
            let result = await updateTeamTaskAsync(this.taskID, patchTask);
            if (result.success) this.$emit("task-updated");

            return true;
        },
        async finishTeamTaskAsync(): Promise<boolean> {
            let patchTask: ApiPatchTask = {
                description: this.localTaskDescription,
                finished: true
            };
            let result = await updateTeamTaskAsync(this.taskID, patchTask);
            if (result.success) this.$emit("task-updated");

            return true;
        }
    }
});
